<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 sm6>
        <span class="headline">{{translate('table.' + entity + '.title')[1]}}</span>
      </v-flex>
      <v-flex xs12 sm6>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-layout row>
        <v-flex xs12>
          <v-data-table
            :loading="loading"
            :no-data-text="emptyTable"
            rows-per-page-text="Registros por página"
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
            :search="search"
            class="elevation-1"
            :custom-filter="customizedFilter" style="word-break: break-all;">
            <template slot="items" slot-scope="props">
              <td  v-if="props.item.name === 'task_comment'">
                <pre style="font-size: 14px; font-family: sans-serif;" v-html="props.item.id_text"></pre>
              </td>
              <v-tooltip bottom v-else :disabled="['task_automation', 'task_automation_password'].includes(props.item.name)">
                <tr slot="activator">
                  <!-- Aumentar área "clicável" da linha na tabela => style="width: 1400px"(ou mais) no TD -->
                  <td>
                    <pre style="font-size: 14px; font-family: sans-serif; margin-top: 15px" v-html="props.item.id_text"></pre>
                  </td>
                </tr>
                <span v-if="!['task_automation', 'task_automation_password'].includes(props.item.name)">
                  <v-layout row justify-center>
                    <p-other-field title="Valores antigos" v-if="(props.item.type).indexOf('alterou') != -1" :othersFields="othersFields(props.item.old, props.item.name)"></p-other-field>
                    <p-other-field title="Valores novos" :othersFields="othersFields(props.item.new, props.item.name)"></p-other-field>
                  </v-layout>
                </span>
              </v-tooltip>
              <td slot="activator" class="text-xs-right field-time">{{props.item.time}}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<style>
.field-time {
  color: #949494;
  font-size: 12px !important;
}
</style>


<script>
import POtherField from './../shared/POtherField'

export default {
  components: {POtherField},
  data: () => ({
    entity: 'activity_log',
    search: '',
    loading: false,
    pagination: {
      sortBy: 'id',
      descending: true
    },
    items: []
  }),
  name: 'TaskLog',
  props: ['task_id'],
  created () {
    this.loading = true
    this.$http.get(`api/${this.entity}_task/${this.task_id}`).then(res => {
      this.items = res.body
      this.$emit('itemsLength', this.items.length)
      this.loading = false
    })
  },
  methods: {
    othersFields (item, name) {
      let result = []
      let keys = Object.keys(item)
      for (var i in keys) {
        result.push({field: this.translate('table.' + name + '.field.' + keys[i]), value: item[keys[i]]})
      }
      return result
    },
    customizedFilter (items, search, filter) {
      search = search.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return items.filter(i => (
        (i['id_text'] ? filter(i['id_text'].toString().replace(/(<([^>]+)>)/ig, '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), search) : false) || (i['time'] ? filter(i['time'].toString(), search) : false)
      ))
    }
  },
  computed: {
    headers: function () {
      return [
        {text: this.translate('table.' + this.entity + '.field.attributes'), value: 'id_text', sortable: false},
        {value: 'action', sortable: false}
      ]
    },
    emptyTable () {
      return 'Ainda não foram cadastrados registros de ' + this.translate('table.' + this.entity + '.title')[1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/details/TaskLog.vue